import React, { memo } from 'react'
import InfoIcon from 'transfix-icons/build/InfoIcon'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { FUEL_MILEAGE } from 'apps/marketplace/store/amQuoting/types'
import { Tooltip } from 'transfix-ui'

interface ICostCalTableRowProps {
  label: string | FUEL_MILEAGE
  value?: string | number
  stops?: boolean
  tooltip?: string
  multistop?: boolean
  labelClass?: string
  valueClass?: string
}

const useStyles = makeStyles(() => ({
  align: {
    display: 'inline-block',
    verticalAlign: 'middle',
    paddingLeft: '4px',
  },
  fontColor: {
    color: brandColors.coolGray5,
  },
}))

export const CostCalTableRow = memo<ICostCalTableRowProps>(
  ({ label, labelClass, multistop, stops, tooltip, value, valueClass }) => {
    const displayValue = stops ? '-' : value
    const classes = useStyles()

    return (
      <>
        <tr>
          {multistop ? (
            <>
              <td className='pl0'>
                <div className={classes.fontColor}>{label} </div> {displayValue}
              </td>
            </>
          ) : (
            <>
              <td className={`pa0 items-center ${labelClass}`}>
                {label}
                {tooltip && (
                  <span className={classes.align}>
                    <Tooltip position='top' effect='solid' trigger={<InfoIcon size='medium' />}>
                      {tooltip}
                    </Tooltip>
                  </span>
                )}
              </td>
              <td className={`tr ${valueClass}`}>{displayValue}</td>
            </>
          )}
        </tr>
      </>
    )
  }
)
